import { Button, FormControl, TextField, Typography, useTheme } from "@material-ui/core";
import { styled } from "@material-ui/styles";
import PropTypes from "prop-types";
import { useState } from "react";
import { DEFAULT_APPLICATION_TITLE } from "../../../constants";
import { checkPasswordInvalidity } from "../../../utils";
import Banner from "../../Common/Banner";
import DialogForm from "../../Common/DialogForm";
import Error from "../../Common/Error";
import LoadingButton from "../../Common/LoadingButton";
import PrivateTextInput from "../../Common/PrivateTextInput";
import countryList from "../../../data/countries.json";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import { TDialog, TDialogTitle, TDialogActions } from "../../Common/TDialog";

// const parseCountries = (text) => {
//     return text ? text.split(/\r?\n/).filter((country) => country) : [];
// };

const StyledDialogForm = styled(DialogForm)(({ theme }) => ({
    "& .MuiFormControl-root.requirement": {
        margin: theme.spacing(2, 0),
    },
}));

const StyledLeftDialogActionsWrapper = styled("div")({
    flex: "1 0 0",
});

const NO_COUNTRY_ALPHA = "NOCOUNTRY";

const NON_COUNTRY = {
    name: "Choose a country...",
    ISO3_Alpha: NO_COUNTRY_ALPHA,
    ISO3_Numeric: -9999,
};

export const RegistrationDialogPresenter = (props) => {
    const {
        title,
        open,
        splashMessage,
        message,
        // requirement,
        applicationId,
        error,
        completed,
        footerMessage,
        onSignIn,
        saving,
        onSave,
    } = props;

    const [firstName, setFirstName] = useState();
    const [lastName, setLastName] = useState();
    const [email, setEmail] = useState();
    // const [countries, setCountries] = useState();
    const [password, setPassword] = useState();
    const [passwordConfirmation, setPasswordConfirmation] = useState();
    const [position, setPosition] = useState();
    const [organization, setOrganization] = useState();
    const [country, setCountry] = useState(NO_COUNTRY_ALPHA);

    const theme = useTheme();

    const checkValidity = () => {
        return (
            firstName &&
            lastName &&
            email &&
            email.includes("@") &&
            !checkPasswordInvalidity(password) &&
            password === passwordConfirmation &&
            (applicationId === "RNM" ? position : true) &&
            (applicationId === "RNM" ? organization : true) &&
            (applicationId === "RNM" ? country : true) &&
            (applicationId === "RNM" ? country !== NO_COUNTRY_ALPHA : true)
        );
    };

    return (
        <TDialog open={open}>
            <TDialogTitle>{title}</TDialogTitle>

            <StyledDialogForm>
                {splashMessage && <Banner message={splashMessage} color={theme.palette.warning.light} />}

                {message && (
                    <FormControl>
                        <Typography variant="body1">{message}</Typography>
                    </FormControl>
                )}

                {error && (
                    <FormControl>
                        <Error message={error} />
                    </FormControl>
                )}

                {!completed && (
                    <>
                        <TextField
                            label="First name"
                            value={firstName ?? ""}
                            required
                            fullWidth
                            onChange={(e) => {
                                setFirstName(e.target.value);
                            }}
                        />

                        <TextField
                            label="Last name"
                            value={lastName ?? ""}
                            required
                            fullWidth
                            onChange={(e) => {
                                setLastName(e.target.value);
                            }}
                        />

                        <TextField
                            label="Email"
                            value={email ?? ""}
                            required
                            fullWidth
                            onChange={(e) => {
                                setEmail(e.target.value);
                            }}
                        />

                        {/* ***** */}

                        {applicationId === "RNM" && (
                            <>
                                <TextField
                                    label="Position"
                                    value={position ?? ""}
                                    required
                                    fullWidth
                                    onChange={(e) => {
                                        setPosition(e.target.value);
                                    }}
                                />

                                <TextField
                                    label="Organization"
                                    value={organization ?? ""}
                                    required
                                    fullWidth
                                    onChange={(e) => {
                                        setOrganization(e.target.value);
                                    }}
                                />

                                <FormControl fullWidth style={{ marginTop: 15 }}>
                                    <InputLabel id="demo-mutiple-name-label">Country *</InputLabel>
                                    <Select
                                        labelId="demo-mutiple-name-label"
                                        id="demo-mutiple-name"
                                        value={country}
                                        onChange={(e) => {
                                            setCountry(e.target.value);
                                        }}
                                        input={<Input />}
                                        // MenuProps={MenuProps}
                                    >
                                        {[NON_COUNTRY, ...countryList].map((obj) => (
                                            <MenuItem key={obj.name} value={obj.ISO3_Alpha}>
                                                {obj.name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>

                                {/* <TextField
                                    label="Country"
                                    value={country ?? ""}
                                    required
                                    fullWidth
                                    onChange={(e) => {
                                        setCountry(e.target.value);
                                    }}
                                /> */}
                            </>
                        )}

                        {/* ***** */}

                        {/* {requirement && (
                            <TextField
                                multiline
                                variant="outlined"
                                minRows={10}
                                label="Requirement"
                                value={countries ?? ""}
                                required
                                fullWidth
                                helperText={requirement}
                                className="requirement"
                                onChange={(e) => {
                                    setCountries(e.target.value);
                                }}
                            />
                        )} */}

                        <PrivateTextInput
                            label="New password"
                            value={password ?? ""}
                            required
                            fullWidth
                            helperText={checkPasswordInvalidity(password) ?? "Password is valid"}
                            onChange={(e) => {
                                setPassword(e.target.value);
                            }}
                        />

                        <PrivateTextInput
                            label="Confirm password"
                            value={passwordConfirmation ?? ""}
                            required
                            fullWidth
                            helperText={
                                password && password === passwordConfirmation
                                    ? "Password confirmed"
                                    : "Password not confirmed"
                            }
                            onChange={(e) => {
                                setPasswordConfirmation(e.target.value);
                            }}
                        />
                    </>
                )}

                {footerMessage && <Banner message={footerMessage} color={theme.palette.info.light} />}
            </StyledDialogForm>

            {!completed && (
                <TDialogActions>
                    <StyledLeftDialogActionsWrapper>
                        <Button color="secondary" onClick={onSignIn}>
                            Back
                        </Button>
                    </StyledLeftDialogActionsWrapper>

                    <LoadingButton
                        color="primary"
                        disabled={!checkValidity()}
                        loading={saving}
                        onClick={() => {
                            onSave?.({
                                applicationId,
                                firstName,
                                lastName,
                                email,
                                password,
                                position,
                                organization,
                                country,
                            });
                        }}
                    >
                        Create account
                    </LoadingButton>
                </TDialogActions>
            )}
        </TDialog>
    );
};

RegistrationDialogPresenter.propTypes = {
    open: PropTypes.bool.isRequired,
    title: PropTypes.string,
    splashMessage: PropTypes.string,
    footerMessage: PropTypes.string,
    requirement: PropTypes.string,
    saving: PropTypes.bool,
    completed: PropTypes.bool,
    error: PropTypes.string,
    onSave: PropTypes.func,
    onSignIn: PropTypes.func,
};

RegistrationDialogPresenter.defaultProps = {
    title: DEFAULT_APPLICATION_TITLE,
    saving: false,
    completed: false,
};
